// Section 5: Gentle. Never commits violent crime (crime stream reads the trait); will not serve
// as a guard. Constants: config.traits.gentle.
import { defineTrait, noModifiers } from '../../core/registry';
import type { Config } from '../../config';

export function gentle(_config: Config) {
  return defineTrait({
    id: 'gentle',
    label: 'Gentle',
    section: 'S5',
    modifierTargets: [],
    modifiers: noModifiers,
    restricts: (_ctx, person, jobId) => jobId === 'guard' && person.traits.includes('gentle'),
  });
}
